module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.compIsVisible) ? _c('div', {
    staticClass: "upright_overlay_container",
    class: {
      top: _vm.isAlignedTop
    }
  }, [(typeof _vm.compPrevUpright !== 'undefined') ? _c('k1wallupright', {
    attrs: {
      "data": _vm.compPrevUpright,
      "width": _vm.widths[_vm.compPrevUpright.width],
      "height": _vm.heights[_vm.compPrevUpright.height],
      "is-disabled": true,
      "is-selectable": false,
      "is-selected": false
    }
  }, _vm._l((_vm.objects()[_vm.prevIndex]), function(object, obj_index) {
    return _c('k1element', {
      key: ("obj-" + _vm.prevIndex + "-" + obj_index),
      attrs: {
        "is-disabled": true,
        "is-editing": false,
        "pos-slot": object.slot,
        "img": _vm.objectRightWidth(object, _vm.prevIndex).frontal_inactive
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('k1wallupright', {
    attrs: {
      "data": _vm.enableUppers(_vm.compUpright),
      "width": _vm.widths[_vm.compUpright.width],
      "height": _vm.heights[_vm.compUpright.height],
      "is-disabled": false,
      "is-selectable": false,
      "is-selected": false
    }
  }, [_c('transition-group', {
    attrs: {
      "tag": "span"
    },
    on: {
      "before-enter": _vm.beforeEnterAnimation,
      "enter": _vm.enterAnimation,
      "leave": _vm.leaveAnimation
    }
  }, _vm._l((_vm.objects()[_vm.currIndex]), function(object, obj_index) {
    return _c('k1element', {
      key: ("obj-" + _vm.currIndex + "-" + obj_index),
      attrs: {
        "is-disabled": false,
        "is-editing": _vm.objectIndex === obj_index,
        "pos-slot": object.slot,
        "img": _vm.objectRightWidth(object, _vm.currIndex).frontal_inactive,
        "img-editing": _vm.objectRightWidth(object, _vm.currIndex).frontal_active
      },
      on: {
        "click": function($event) {
          _vm.emitEditElement(_vm.currIndex, obj_index, object)
        }
      }
    })
  }))], 1), _vm._v(" "), (typeof _vm.compNextUpright !== 'undefined') ? _c('k1wallupright', {
    attrs: {
      "data": _vm.compNextUpright,
      "width": _vm.widths[_vm.compNextUpright.width],
      "height": _vm.heights[_vm.compNextUpright.height],
      "is-disabled": true,
      "is-selectable": false,
      "is-selected": false
    }
  }, _vm._l((_vm.objects()[_vm.nextIndex]), function(object, obj_index) {
    return _c('k1element', {
      key: ("obj-" + _vm.nextIndex + "-" + obj_index),
      attrs: {
        "is-disabled": true,
        "is-editing": false,
        "pos-slot": object.slot,
        "img": _vm.objectRightWidth(object, _vm.nextIndex).frontal_inactive
      }
    })
  })) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c291fda0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/K1WallOverlay.vue
// module id = 660
// module chunks = 0